import type { AppType } from "@puszczyk/backend/app";
import type { ApiErrorBody } from "@puszczyk/contracts";
import { hc } from "hono/client";

// Typed client generated from the backend routes (Hono RPC, ADR-0001/0002): request and
// response types come from the server code, there is no second set of types to maintain.
export const api = hc<AppType>("/", { init: { credentials: "same-origin" } }).api.v1;

export class ApiRequestError extends Error {
  constructor(
    readonly status: number,
    readonly body: ApiErrorBody | null,
  ) {
    super(body?.error.message ?? `HTTP ${status}`);
  }
  get code() {
    return this.body?.error.code ?? "internal";
  }
}

/** Unwraps a Hono client response: JSON on success, ApiRequestError otherwise. */
export async function unwrap<T>(
  promise: Promise<{ ok: boolean; status: number; json(): Promise<T> }>,
): Promise<T> {
  const res = await promise;
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as unknown as ApiErrorBody | null;
    throw new ApiRequestError(res.status, body);
  }
  return res.json();
}
